import styled from "styled-components"

const FooterSocialItem = styled.li`
  &:hover {
    color: ${(props) => props.theme.b_color_gradients.b_dark};
  }
  color:  ${(props) => props.theme.c_color_gradients.c_dark};
  &>a{
    border: white

    &:hover{
      border: 1px solid ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }
`

export { FooterSocialItem }
